import React from "react";
import PlayerScorecard from "./PlayerScorecard";
import "./PlayerInfoDisplay.css";

export default function PlayerInfoDisplay(props) {
  return (
    <div className="player-info-display">
      <React.Suspense fallback={<></>}>
        <PlayerScorecard
          scorecardId={props.scorecardId}
          roundNumber={props.roundNumber}
        />
      </React.Suspense>
    </div>
  );
}
